import "./OnlineConsulting.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Modalities from "./sections/Modalities";
import Appointment from "./sections/Appointment";
import Footer from "@/reusable_sections/Footer";
export default function OnlineConsultingPage() {
  return <div>
      <Header />
      <Consultation />
      <Modalities />
      <Appointment />
      <Footer />
    </div>;
}